/**
 * Replace all occurrences of a string with another string.
 * @param {string} str
 * @param {object} obj
 */
export default (str, obj) => {
    let returnString = str;
    for (const x in obj) {
        returnString = returnString.replace(new RegExp(x, 'g'), obj[x]);
    }

    return returnString;
};
